import React from 'react';
import './LinkLive.scss';
import './LinkLive-media.scss';
import { EnumUrlsPages } from '../../services/Enum';

import {content} from "../../services/content";
import {Link} from "../Link/Link";

export const LinkLive = (onClick?: any) => {
  return (
    <Link to={EnumUrlsPages.live} onClick={onClick}>
      <h4 className="link-live">{content.header.textsMenu.live}</h4>
    </Link>
  );
};

export default LinkLive;
